<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @on-load="onLoad"
                   @refresh-change="onLoad"
        >
            <template slot="menuLeft">
                <el-button type="danger"
                           size="small"
                           icon="el-icon-delete"
                           plain
                           v-if="permission.valueboundary_delete"
                           @click="handleDelete">删 除
                </el-button>
            </template>
        </avue-crud>
    </basic-container>
</template>

<script>
import { add, getDetail, getList, remove, update } from '@/api/crmedical/value/valueboundary';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      form: {},
      query: {},
      loading: true,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      option: {
        searchMenuSpan: 8,
        height: '400',
        calcHeight: 600,
        tip: false,
        border: true,
        index: true,
        viewBtn: true,
        selection: true,
        column: [
          {
            label: '边界类型',
            prop: 'boundaryType',
            type: 'select',
            search: true,
            dataType: 'number',
            dicUrl: '/api//v4ward/valueBoundary/getType',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: true,
                message:
                  '请输入分析类别，后勤服务(支持服务/物质供应/创新服务),运行保障(基础设施/医用设施/安全设施)',
                trigger: 'blur',
              },
            ],
          },
          {
            label: '内容名称',
            prop: 'name',
            search: true,
            maxlength:'20',
            rules: [
              {
                required: true,
                message: '请输入内容名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '排序',
            prop: 'sortNum',
            type: 'number',
            minRows:'0',
            maxRows:'100',
            rules: [
              {
                required: true,
                message: '请输入排序字段',
                trigger: 'blur',
              },
            ],
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(['permission']),
    permissionList() {
      return {
        addBtn: this.vaildData(this.permission.valueboundary_add, false),
        viewBtn: this.vaildData(this.permission.valueboundary_view, false),
        delBtn: this.vaildData(this.permission.valueboundary_delete, false),
        editBtn: this.vaildData(this.permission.valueboundary_edit, false),
      };
    },
    ids() {
      let ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(',');
    },
  },
  methods: {
    rowSave(row, loading, done) {
      add(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowUpdate(row, index, loading, done) {
      update(row).then(
        () => {
          loading();
          this.onLoad();
          this.$message.success('操作成功!');
        },
        (error) => {
          done();
          console.log(error);
        }
      );
    },
    rowDel(row) {
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: row.id });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
        });
    },
    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning('请选择至少一条数据');
        return;
      }
      this.$confirm('确定将选择数据删除?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          return remove({ ids: this.ids });
        })
        .then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.$refs.crud.toggleSelection();
        });
    },
    beforeOpen(done, type) {
      if (['edit', 'view'].includes(type)) {
        getDetail({ id: this.form.id }).then(({ data }) => {
          this.form = data;
        });
      }
      done();
    },
    searchReset() {
      this.query = {};
      this.onLoad();
    },
    searchChange(params, done) {
      this.query = params;
      this.page.currentPage = 1;
      this.onLoad();
      done();
    },
    selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    onLoad(page) {
      page = page || this.page;
      this.loading = true;
      getList(Object.assign({ current: page.currentPage, size: page.pageSize }, this.query)).then(
        ({ data }) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        }
      );
    },
  },
};
</script>

<style>
</style>
